import { Overlay, RepositionScrollStrategy } from '@angular/cdk/overlay';
import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContentfulContextualHelp, ContentfulUrlAnchor } from '@clux-models';
import { Observable } from 'rxjs';
import { MoreInfoComponent } from 'src/app/shared/components/more-info/more-info.component';
import { ContentfulService } from '../../services/contentful.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-more-info-link',
  templateUrl: './more-info-link.component.html',
  styleUrls: ['./more-info-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe],
})
export class MoreInfoLinkComponent implements OnInit {
  private dialog = inject(MatDialog);
  private overlay = inject(Overlay);
  private contentfulService = inject(ContentfulService);

  @Input() public title: string;
  @Input() public desc: string;
  @Input() public width: number;
  @Input() public anchor?: ContentfulUrlAnchor;

  public contextualHelp$: Observable<ContentfulContextualHelp>;

  public ngOnInit(): void {
    this.getContextualHelpForCurrentUrl();
  }

  private getContextualHelpForCurrentUrl(): void {
    this.contextualHelp$ = this.contentfulService.getContextualHelpForCurrentUrl(this.anchor);
  }
  /**
   * This method is used to open the dialog of more info for this section.
   */
  public openDialog(contextualHelp: ContentfulContextualHelp): void {
    const scrollStrategy: RepositionScrollStrategy = this.overlay.scrollStrategies.reposition();
    this.dialog.open(MoreInfoComponent, {
      disableClose: true,
      data: {
        data: contextualHelp,
      },
      position: {
        top: '7%',
      },
      width: this.width + 'px',
      autoFocus: false,
      scrollStrategy,
    });
  }
}
